import '@src/styles/balanceUpload/bankContract.scss';
import '@src/styles/autoUploadInstruction/bankContract.scss';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomImage, Text } from '@src/components';

import { setCurrentBank } from '@src/store/slice/bankSlice';
import PropTypes from 'prop-types';

const BankContract = ({ containerClass = 'bank-contract' }) => {
    const dispatch = useDispatch();

    const { currentBank } = useSelector((state) => state?.bank);

    const toggleContract = async () => {
        await dispatch(setCurrentBank(null));
    };

    return (
        <div className={containerClass}>
            <div className="custom-card-header">
                <div className="title">
                    <Text t="paymentInformation" />
                </div>
                <button
                    type="button"
                    onClick={toggleContract}
                    className="toggle-contract"
                >
                    <Text t="changePaymentType" />
                </button>
            </div>

            <div className="custom-card-body">
                <div className="bank-info">
                    <span className="bank-logo">
                        {currentBank?.image && (
                            <CustomImage src={`data:image/jpeg;base64,` + currentBank?.image} />
                        )}
                    </span>
                    <span className="bank-name">
                        <span className="bold-text">{currentBank?.bankName}</span>{' '}
                        <Text t="withInstantTransfer" />
                    </span>
                </div>
                <hr />
                <div className="contract-statement-title">
                    <Text t="distanceSalesAgreement" />
                </div>
                <div className="contract-statement">
                    <p className="contract-statement-text">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. A ad adipisci aut autem
                        consequatur culpa deserunt dicta eaque earum enim est eum eveniet excepturi
                        exercitationem facere harum incidunt ipsa itaque iusto laboriosam laborum laudantium
                        minima, necessitatibus nemo nihil obcaecati officiis omnis porro possimus quae quaerat
                        quas reprehenderit sint suscipit ullam vitae voluptatem. Accusamus, ad aperiam, aut cum
                        dolorum eos, hic maxime minima nisi odit porro quidem reiciendis. Aliquid consectetur
                        consequatur cumque ducimus eaque earum eius ipsam nulla quos! Ab amet assumenda autem
                        commodi consequatur culpa delectus dolorum fugit harum illo impedit libero magnam magni
                        neque, nesciunt non nostrum obcaecati officia, optio ratione sit temporibus ullam vel
                        vero voluptas! Blanditiis dicta doloremque excepturi inventore nemo non vitae. Alias
                        amet aspernatur consectetur delectus dicta ea earum, ex facilis impedit in labore,
                        libero nobis porro quam quibusdam ratione reprehenderit sit tempora temporibus veniam
                        voluptate voluptatem voluptates! Aliquid consequuntur excepturi id in numquam optio
                        placeat. Ab, ad beatae debitis deleniti doloribus eius enim est hic illum labore libero
                        magni maxime necessitatibus nesciunt nisi non odit porro quidem reiciendis. Accusamus
                        aliquam aliquid assumenda consequuntur deleniti dolores eligendi explicabo facilis
                        fugiat laborum, nam nemo nobis omnis porro possimus provident quae quo quod recusandae
                        repellat repellendus sapiente sed sint suscipit tempore ullam voluptatem voluptatibus.
                        Adipisci dolorum, ea esse est eum explicabo hic ipsam, itaque magnam nam nemo nesciunt
                        optio perferendis placeat praesentium qui, quisquam sed soluta velit veritatis! Alias
                        aliquam architecto at, atque consequuntur cupiditate deserunt dicta distinctio dolore
                        dolores dolorum enim esse est eum ex excepturi facere illum incidunt iusto magnam
                        molestias mollitia nam neque nihil nostrum officiis optio, quae quaerat quibusdam quidem
                        sed sit tempora temporibus ullam vel veniam veritatis. Aspernatur blanditiis dolores
                        doloribus explicabo fugit labore laborum, maxime modi nostrum nulla odit perferendis
                        perspiciatis qui repellendus sequi sint sunt temporibus voluptates! Ab delectus
                        doloremque dolorum facilis harum magnam mollitia natus neque officia, porro quam
                        repellat sed tenetur ullam voluptatem. At atque id, ipsam laboriosam molestiae porro!
                        Enim nesciunt quidem quod unde! Ab beatae distinctio ea error id ipsum nam quaerat, qui,
                        quidem quisquam quo, tempore voluptatum. Ad at distinctio ducimus enim et fuga libero,
                        necessitatibus obcaecati, odio, perferendis quia voluptates. Adipisci aliquam animi at
                        culpa dignissimos distinctio dolore expedita fugiat id incidunt ipsa iste iure iusto
                        laboriosam laborum molestiae nesciunt nisi non nulla numquam obcaecati, omnis quae quam
                        quisquam quo quod ratione repellat rerum sapiente sed similique tempora ut veniam vitae
                        voluptas voluptate voluptatum. Accusantium debitis enim incidunt molestiae voluptate? Ab
                        adipisci alias, aliquam aperiam architecto atque aut consectetur culpa deleniti deserunt
                        dolorem doloribus eaque fugiat ipsum magnam maiores maxime molestiae nemo officiis optio
                        porro possimus quae recusandae repellendus repudiandae rerum sed tempore veniam
                        voluptatem voluptatibus? Adipisci aliquam aliquid animi aperiam, asperiores assumenda
                        aut autem commodi culpa, cum dolores enim eveniet fugiat fugit laborum magni maiores
                        mollitia nam nemo non nostrum perspiciatis quae quaerat quas quos rem reprehenderit
                        sequi soluta temporibus ullam vel velit voluptatem voluptatibus? Ad adipisci architecto
                        consequuntur dolore enim error facilis laborum, neque nesciunt nihil officia quaerat
                        quisquam, rerum, sequi sit voluptas voluptatum. A, aut corporis cumque dolore doloremque
                        dolorum est facere fuga impedit ipsa iusto nostrum optio perspiciatis provident quas qui
                        quidem saepe vel! Atque autem consequuntur eos est facere, harum incidunt itaque iusto
                        magnam nesciunt nulla obcaecati optio pariatur perspiciatis quisquam ratione recusandae
                        sunt tenetur, ullam veritatis? In modi numquam placeat quam reiciendis temporibus ullam
                        voluptatibus. Dolor, eum, harum? Accusantium aliquam, architecto dolores enim esse fugit
                        impedit inventore ipsum nobis obcaecati officiis quaerat quam quibusdam quos reiciendis
                        reprehenderit temporibus, vel veritatis? Accusamus asperiores assumenda, earum eligendi
                        et, impedit ipsa maiores placeat porro quae quasi repellat ullam voluptatibus. A animi
                        assumenda at blanditiis, eius illo ipsam, molestiae nemo non quas quo ullam. Eveniet
                        laudantium minus, molestias neque quaerat saepe vero voluptatem! Adipisci, aspernatur
                        dolor ducimus earum eum fugit in inventore itaque maxime nemo nihil numquam perferendis
                        porro sapiente sit tenetur vel? Assumenda consequuntur ea incidunt sint totam ullam ut.
                        Doloribus dolorum eligendi harum illum, inventore libero nesciunt nihil nulla, obcaecati
                        officia pariatur qui rerum sequi sit totam. Autem cum dignissimos illum sint. Atque
                        culpa distinctio eius inventore maxime quos repellendus, sunt tempore. Accusamus
                        aspernatur blanditiis consequuntur distinctio ducimus enim eveniet fugiat, id in iure
                        maiores molestiae qui quia quidem temporibus. Aliquid autem culpa, dignissimos dolorem
                        dolorum esse inventore laboriosam maxime minima nam nemo neque nesciunt nostrum odit
                        officia officiis, perferendis rem sapiente sed sint sit sunt unde veritatis vitae
                        voluptate. Consequatur cum, distinctio dolore dolorum ea eius est facere illo labore
                        laborum necessitatibus nemo non, officiis quia recusandae sint voluptas. Alias aliquid
                        aut beatae, deserunt dignissimos doloribus dolorum hic magnam minus molestias, natus
                        quod repellendus sint totam ullam unde voluptatum? Asperiores illum inventore molestias
                        provident ullam vitae! Beatae consectetur doloremque, dolorum earum et in molestias
                        neque nulla odio officiis placeat praesentium suscipit. Ab aliquam asperiores corporis
                        cum cumque dolor et harum id, impedit incidunt inventore ipsa maiores maxime odio
                        praesentium provident quibusdam quidem quod, rem saepe sit temporibus totam ullam vel
                        vitae. Accusantium earum in rem repellat sapiente tempora ullam voluptatum. Aliquam
                        aliquid aspernatur distinctio ea est inventore laborum nobis odit reprehenderit
                        voluptas? Cum, deleniti, dolore eaque illo labore maxime nostrum nulla obcaecati optio
                        perferendis placeat, provident ratione sit velit voluptatem. Alias aliquid, animi,
                        delectus, dignissimos est explicabo ipsam ipsum iure magni odio porro quidem quos rem
                        ullam ut veniam voluptate. Assumenda culpa exercitationem, mollitia, odio optio possimus
                        quae quo saepe sapiente sit totam, voluptatem! Culpa earum neque quos reiciendis sed
                        veritatis. Accusamus aliquid architecto aut corporis deleniti deserunt dignissimos
                        dolorem, doloremque dolores ducimus excepturi exercitationem impedit ipsa iste itaque
                        laboriosam laborum magni molestiae nam necessitatibus non nostrum obcaecati officiis
                        optio perferendis perspiciatis placeat qui, quo recusandae reiciendis repellat
                        repudiandae sapiente ullam, ut velit voluptate voluptates! Ad corporis, debitis delectus
                        dicta doloremque eaque iure laboriosam necessitatibus nesciunt nobis nostrum provident,
                        quam ratione repellat rerum sunt suscipit. Architecto error impedit quisquam. Aliquid
                        beatae culpa dolorem excepturi facilis incidunt laboriosam magnam maxime neque officia
                        optio provident quas repellendus, repudiandae sed sint ullam velit!
                    </p>
                </div>
            </div>
        </div>
    );
};

BankContract.propTypes = {
    containerClass: PropTypes.string,
};

export default BankContract;
